import { render, staticRenderFns } from "./CommentUserBalloon.vue?vue&type=template&id=4410bf56"
import script from "./CommentUserBalloon.vue?vue&type=script&lang=js"
export * from "./CommentUserBalloon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports